import $ from 'jquery';

export default function typeFilterSearch() {

  // Apre il pannello dei filtri e porta il focus sul primo radio
  function openFilter($choose, $button) {
    const $firstRadio = $choose.find('input[type="radio"]').first();
    $choose.addClass('open');
    // $button.attr('aria-expanded', 'true');
    $firstRadio.focus();
  }

  // Chiude il pannello dei filtri; se non riceve parametri chiude globalmente
  function closeFilter($choose, $button) {
    if ($choose && $button) {
      $choose.removeClass('open');
      // $button.attr('aria-expanded', 'false').focus();
    } else {
      const $choose = $('.intranet-search__choose');
      const $type = $('.intranet-search__type');
      $choose.removeClass('open');
      // $type.attr('aria-expanded', 'false');
    }
  }

  // Apre il dropdown dei risultati associato all'input
  function openResults($input) {
    // $input.attr('aria-expanded', 'true');
    $input.parents('.intranet-search').addClass('open');
  }

  // Chiude il dropdown dei risultati
  function closeResults($input) {
    // $input.attr('aria-expanded', 'false');
    $input.parents('.intranet-search').removeClass('open');
  }

  function init() {
    // Chiusura globale: click o focus fuori dal componente
    $(document).on('click focusin', function (event) {
      if (!$(event.target).closest('.intranet-search').length) {
        closeFilter();
        closeResults($('.intranet-search__text'));
      }
    });

    // Toggle apertura/chiusura filtro da bottone
    $('.intranet-search__type').on('click', function () {
      const $choose = $(this).parents('.intranet-search__choose');
      const isOpen = $choose.hasClass('open');
      if (!isOpen) {
        openFilter($choose, $(this));
      } else {
        closeFilter($choose, $(this));
      }
      $(this).attr('aria-expanded', !isOpen);
    });

    // Apertura filtro via tastiera (Enter o Space)
    $('.intranet-search__type').on('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openFilter($(this).parents('.intranet-search__choose'), $(this));
      }
    });
    
    // Navigazione tra radio del filtro con frecce e chiusura con ESC
    $('.intranet-search__filter').on('keydown', 'input[type="radio"]', function (e) {
      const $radios = $(this).closest('.intranet-search__filter').find('input[type="radio"]');
      const index = $radios.index(this);
      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          $radios.eq((index + 1) % $radios.length).focus();
          break;
        case 'ArrowUp':
          e.preventDefault();
          $radios.eq((index - 1 + $radios.length) % $radios.length).focus();
          break;
        case 'Escape':
          const $choose = $(this).parents('.intranet-search__choose');
          closeFilter($choose, $choose.find('.intranet-search__type'));
          break;
      }
    });
  }

  function filter() {
    // Gestione selezione filtro (click e tastiera)
    $('.intranet-search__filter-label').on('click keydown', function (e) {
      if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      const $label = $(this);
      const textLabel = $.trim($label.text());
      const actionForm = $label.data('action');
      const id = $label.find('input').attr('id');
      $label.find('input').prop('checked', true);
      $('.intranet-search__filter-label').attr('aria-checked', 'false');
      $label.attr('aria-checked', 'true');
      $('.intranet-search__type').html(textLabel).attr('aria-expanded', 'false').focus();
      $('.intranet-search__choose').removeClass('open');
      $('.intranet-search__form').attr('action', actionForm);
      $('.intranet-search__link').attr('href', actionForm);
      
      if (id === 'all') {
        $('.intranet-search__box').removeClass('d-none');
      } else {
        $('.intranet-search__box').addClass('d-none');
        $('.intranet-search__box--' + id).removeClass('d-none');
      }
    });

    // Porto il focus sui badge di ricerca, se presenti, al caricamento della pagina
    function focusOnResultBadges() {
      const hasVisibleBadges = $('.intranet-search-grid__badge').not('.d-none').length > 0;

      if (hasVisibleBadges) {
        $('.intranet-search-grid__result-badges').focus();
      }
    }

    focusOnResultBadges();
  }

  function showResults() {
    const $input = $('.intranet-search__text');

    // Apertura/chiusura risultati in base alla lunghezza input
    $input.on('input focus', function () {
      const $this = $(this);
      const value = this.value.trim();
      if (value.length >= 3) {
        openResults($this);
      } else {
        closeResults($this);
      }
    });

    // Gestione tastiera: ESC chiude, freccia giù entra nei risultati
    $input.on('keydown', function (e) {
      if (e.key === 'Escape') {
        closeResults($(this));
        this.blur();
      }
      if (e.key === 'ArrowDown') {
        const $first = $('.intranet-search__dropdown a:visible').first();
        if ($first.length) {
          e.preventDefault();
          $first.focus();
        }
      }
    });
    
    // Chiusura se il focus esce completamente dal componente
    $input.on('blur', function () {
      const input = $(this);
      setTimeout(() => {
        const active = document.activeElement;
        if ($(active).closest('.intranet-search').length) return;
        closeResults(input);
      }, 0);
    });
    
    // ESC nei risultati: chiude e riporta focus all'input
    $('.intranet-search__dropdown').on('keydown', 'a', function (e) {
      if (e.key === 'Escape') {
        const $input = $('.intranet-search__text');
        closeResults($input);
        $input.focus();
      }
    });
  }

  $(document).ready(function () {
    if ($('.intranet-search__type').length) init();
    if ($('.intranet-search__filter').length) filter();
    if ($('.intranet-search__text').length) showResults();
  });
}